import React from 'react';
import { Button, Icon, Form, List } from 'tabler-react';
import toast from 'cogo-toast';

class TrialCards extends React.Component {
  handleCopy = () => {
    document.querySelector('[name="share-text"]').select();
    document.execCommand('copy');
  };

  handleCopyLink = () => {
    document.querySelector('[name="share-link"]').select();
    document.execCommand('copy');
    toast.success('已复制');
  };

  render() {
    const { shareText, referLink } = this.props;
    return (
      <div className="miao-share">
        <Form.Group
          label={
            <Form.Label>
              邀请文本
              <Button
                className="copy-btn"
                color="secondary"
                size="sm"
                pill
                onClick={this.handleCopy}>
                <Icon name="copy" />
                复制
              </Button>
            </Form.Label>
          }>
          <Form.Textarea
            rows={4}
            name="share-text"
            value={shareText}
            readOnly
          />
        </Form.Group>
        <Button.List className="malus-social-group" align="left">
          <Button
            social="facebook"
            RootComponent="a"
            href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
              referLink,
            )}`}
            target="_blank">
            分享到 Facebook
          </Button>
          <Button
            social="twitter"
            RootComponent="a"
            href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(
              shareText,
            )}`}
            target="_blank">
            分享到 Twitter
          </Button>
          <Button
            social="weibo"
            RootComponent="a"
            href={`http://service.weibo.com/share/share.php?title=${encodeURIComponent(
              shareText,
            )}`}
            target="_blank">
            分享到 Weibo
          </Button>
        </Button.List>
        <Form.Group label="活动规则">
          <List>
            <List.Item>好友激活一张体验卡,你将会获得同等时长</List.Item>
            <List.Item>
              单一IP最多允许 <strong>3</strong> 张卡
            </List.Item>
          </List>
        </Form.Group>
      </div>
    );
  }
}

export default TrialCards;
